"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.VARIANT = exports.TYPE = exports.SIZE = exports.SHAPE = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SHAPE = {
  SOLID: 'solid',
  PILL: 'pill'
};
exports.SHAPE = SHAPE;
const SIZE = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
exports.SIZE = SIZE;
const TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
  LINK: 'link',
  MENU: 'menu'
};
exports.TYPE = TYPE;
const VARIANT = {
  PRIMARY: TYPE.PRIMARY,
  SECONDARY: TYPE.SECONDARY,
  ERROR: TYPE.ERROR,
  WARNING: TYPE.WARNING,
  SUCCESS: TYPE.SUCCESS
};
exports.VARIANT = VARIANT;
const defaultProps = {
  size: SIZE.MD,
  progress: false,
  disabled: false,
  selected: false,
  shape: SHAPE.SOLID
};
exports.defaultProps = defaultProps;
const propTypes = {
  className: _propTypes.default.string,
  progress: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  size: _propTypes.default.oneOf(Object.values(SIZE)),
  shape: _propTypes.default.oneOf(Object.values(SHAPE)),
  type: _propTypes.default.oneOf(Object.values(TYPE))
};
exports.propTypes = propTypes;
//# sourceMappingURL=props.js.map